var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalculator = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5.25171,
    fill: "#F4EFFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7238 69.9161L24.1989 67.1864C23.5376 66.7875 23.1333 66.0714 23.1333 65.2991L23.1333 27.5499C23.1333 26.3501 23.423 25.3592 24.1728 24.7593L28.5324 27.25L28.7238 69.9161Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9325 27.2501L23.8179 25.1861C24.1778 24.5862 24.483 24.5505 24.933 24.2506L49.2221 10.1658C49.8795 9.78456 50.6869 9.76886 51.3586 10.1242L55.5586 12.3463L27.9325 27.2501Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3721 12.0647L28.482 26.7042C28.0497 26.9486 27.7825 27.4067 27.7825 27.9033L27.7825 68.9701C27.7825 70.0276 28.9245 70.6908 29.8429 70.1667L55.733 55.3917C56.1626 55.1465 56.4278 54.6898 56.4278 54.1952V13.2639C56.4278 12.2089 55.2905 11.5455 54.3721 12.0647Z",
    fill: "#F7F4FD",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7817 38.1976L30.7817 30.0989L53.1281 17.051V25.1497L30.7817 38.1976Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3804 36.5486L30.782 42.2477V51.9961L40.3804 46.447V36.5486Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3807 49.4463L30.7822 55.1454V64.8938L40.3807 59.3447V49.4463Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8287 29.3501L43.2302 35.0492V44.7976L52.8287 39.2485V29.3501Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8282 42.2476L43.2297 47.9466V57.695L52.8282 52.1459V42.2476Z",
    fill: "#F1B9FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2786 20.6514L48.4789 22.0011V25.7505L50.2786 24.7007V20.6514Z",
    fill: "#B7C2FF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.581 41.7979V47.1971M33.1814 45.6973L37.5307 42.9977M46.2293 38.3485L50.2786 35.9489M33.7813 56.0456L37.5307 58.2952M33.7813 59.945L36.9308 54.3959M48.4789 22.0011L50.2786 20.6514V24.7007L48.4789 25.7505V22.0011Z",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2295 51.2458L50.2788 48.8462",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.0291,
    cy: 48.2461,
    r: 0.599902,
    fill: "#040222"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.3287,
    cy: 51.8455,
    r: 0.599902,
    fill: "#040222"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalculator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calculator.a4ff4e2428ee730679a576a81faff705.svg";